module.exports = __webpack_public_path__ + "img/m3_t1_en.64b8b085.svg";